import { schema } from 'normalizr';

export const PROJECT_ACTIVITY_SCHEMA_KEY = 'projectActivities';
export const USER_ACTIVITY_SCHEMA_KEY = 'userActivities';
export const ENTITY_CONTEXT_SCHEMA_KEY = 'entityContext';
export const USERS_SCHEMA_KEY = 'users';

export type ActivitySchemaKeys = 'projectActivities' | 'userActivities';

export const entityContextSchema = new schema.Entity(ENTITY_CONTEXT_SCHEMA_KEY);
export const userSchema = new schema.Entity(USERS_SCHEMA_KEY);

export const projectActivitySchema = new schema.Entity(PROJECT_ACTIVITY_SCHEMA_KEY, {
  entity: entityContextSchema,
  user: userSchema,
});

export const projectActivityListSchema = [projectActivitySchema];

export const userActivitySchema = new schema.Entity(USER_ACTIVITY_SCHEMA_KEY, {
  entity: entityContextSchema,
  user: userSchema,
});

export const userActivityListSchema = [userActivitySchema];
